import ApplicationController from '../application_controller'

class SidenavMobileController extends ApplicationController {
  connect () {
    this.scrollPosition = 0

    // Toggle sidenav when button is clicked
    document.querySelectorAll('.sidenav-toggle-button').forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault()
        if (document.body.classList.contains('sidenav-expanded')) {
          this.closeSidenav()
        } else {
          this.openSidenav()
        }
      })
    })

    // Close sidenav when overlay is clicked
    const overlay = document.querySelector('.sidenav-overlay')
    if (overlay) {
      overlay.addEventListener('click', () => {
        this.closeSidenav()
      })
    }

    // Close sidenav when close button is clicked
    document.querySelectorAll('.sidenav-close-button').forEach((button) => {
      button.addEventListener('click', () => {
        this.closeSidenav()
      })
    })

    // Close sidenav when escape key is pressed
    document.addEventListener('keyup', e => {
      if (e.key === 'Escape' && document.body.classList.contains('sidenav-expanded')) {
        this.closeSidenav()
      }
    })
  }

  openSidenav () {
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop
    document.body.classList.add('sidenav-expanded')
    document.body.style.top = `-${this.scrollPosition}px`
  }

  closeSidenav () {
    document.body.classList.remove('sidenav-expanded')
    document.body.style.top = ''
    window.scrollTo(0, this.scrollPosition)
  }
}

export default SidenavMobileController
